<ng-container *ngIf="nzStatus || nzColor">
  <span [class]="'ant-badge-status-dot ant-badge-status-' + (nzStatus || presetColor)" [style.background]="!presetColor && nzColor" [ngStyle]="nzStyle"></span>
  <span class="ant-badge-status-text">
    <ng-container *nzStringTemplateOutlet="nzText">{{ nzText }}</ng-container>
  </span>
</ng-container>
<ng-content></ng-content>
<ng-container *nzStringTemplateOutlet="nzCount">
  <ui-badge-sup
    *ngIf="showSup"
    [uiSize]="size"
    [a11yLabel]="a11yLabel"
    [uiOffset]="nzOffset"
    [uiTitle]="nzTitle"
    [uiStyle]="nzStyle"
    [uiDot]="nzDot"
    [uiOverflowCount]="nzOverflowCount"
    [uiCount]="nzCount"></ui-badge-sup>
</ng-container>
